import { ContractName, getContract } from 'decentraland-transactions';
import { TradesAPI } from './api';
import { getOnChainTrade } from '../../lib/trades';
import { sendTransaction } from '../wallet/utils';
export class TradeService {
    tradesAPI;
    constructor(signer, basePath, getIdentity) {
        this.tradesAPI = new TradesAPI(signer, basePath, {
            identity: getIdentity,
            retries: 0
        });
    }
    async addTrade(trade) {
        return this.tradesAPI.addTrade(trade);
    }
    async fetchTrade(tradeId) {
        return this.tradesAPI.fetchTrade(tradeId);
    }
    async accept(trade, sentBeneficiaryAddress) {
        const offchainMarketplaceContract = getContract(ContractName.OffChainMarketplace, trade.chainId);
        const tradeToAccept = getOnChainTrade(trade, sentBeneficiaryAddress);
        return sendTransaction(offchainMarketplaceContract, 'accept', [
            tradeToAccept
        ]);
    }
    async cancel(trade, sentBeneficiaryAddress) {
        const offchainMarketplaceContract = getContract(ContractName.OffChainMarketplace, trade.chainId);
        const tradeToCancel = getOnChainTrade(trade, sentBeneficiaryAddress);
        return sendTransaction(offchainMarketplaceContract, 'cancelSignature', [
            tradeToCancel
        ]);
    }
}
//# sourceMappingURL=TradeService.js.map